module.exports = __webpack_public_path__ + "static/media/valor.33217043.jpg";